import { BASE } from "./index";
import axios from "./http";
const member = {
  // 用户标签列表
  memberlist: (params) => axios.post(`${BASE.PRO1}/member/label/list`, params),
  //编辑/新增标签
  memberlabelstore: (params) =>
    axios.post(`${BASE.PRO1}/member/label/store`, params),
  //清除标签
  memberlabelclear: (params) =>
    axios.post(`${BASE.PRO1}/member/label/clear`, params),
  //导入关联用户
  memberlabelbindimport: (params) =>
    axios.post(`${BASE.PRO1}/member/label/bind/import`, params),
  //下拉列表
  memberlabelall: (params) =>
    axios.post(`${BASE.PRO1}/member/label/all`, params),
  //标签绑定
  memberLabelBind: (params) =>
    axios.post(`${BASE.PRO1}/member/label/bind`, params),
  //标签下拉列表
  memberLabelType2: (params) =>
    axios.post(`${BASE.PRO1}/member/label/type2`, params),
  //会员标签绑定列表
  memberLabelBindList: (params) =>
    axios.post(`${BASE.PRO1}/member/label/bind/list`, params),
  //会员下拉筛选条件
  memberconditionlist: (params) =>
    axios.get(`${BASE.PRO1}/member/condition/value/list`, params),
  //会员标签删除
  memberdellabel: (params) =>
    axios.post(`${BASE.PRO1}/member/del/label`, params),
  //客户注销列表
  deletelist: (params) =>
    axios.post(`${BASE.PRO1}/member/delete/list`, params),
  //客户注销用户列表
  deleteaudit: (params) =>
    axios.post(`${BASE.PRO1}/member/delete/audit`, params),
  //客户注销用户列表
  searchinfo: (params) =>
    axios.post(`${BASE.PRO1}/member/search/info`, params),
  //客户注销用户列表
  deletesave: (params) =>
    axios.post(`${BASE.PRO1}/member/delete/save`, params),
};

export default member;